import React from 'react'

import HtmlContent from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/HtmlContent'
import SectionContainer from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/SectionContainer'
import SectionHeading from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/SectionHeading'
import { useRecommendedPartner } from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartner'

const WhatOurClientsSay: React.FC = () => {
  const partner = useRecommendedPartner()

  return (
    <SectionContainer>
      <SectionHeading>What our clients say about us</SectionHeading>

      <HtmlContent
        html={partner.clientTestimonials || ''}
        style={{ maxWidth: '600px' }}
      />
    </SectionContainer>
  )
}

export default WhatOurClientsSay
